export default {
      id: "sort-active-usage",
      viewBox: "0 0 7 10",
      url: __webpack_public_path__ + "app/svg/sprite.svg#sort-active",
      toString: function () {
        return this.url;
      }
    }